// import React from "react";
import backgroundOrange from "../../assets/images/inicio/fondo naranja.png";
import lines from "../../assets/images/inicio/lineas.png";
import logo from "../../assets/images/inicio/logo el industrial.png";
import serviceIcon from "../../assets/images/inicio/icono publicidad.png";
import ServiceIcon from "../../components/ServiceIcon";
import disenioIcon from "../../assets/images/inicio/icono diseno.png";
import promotionIcon from "../../assets/images/inicio/icono promocion.png";
import { Link } from "react-router-dom";
import "./BgOrange.css";

const BgOrange = () => {
  return (
    <section className="bg-orange-section">
      {/* Imagen de fondo */}
      <img
        src={backgroundOrange}
        alt="Fondo Naranja"
        className="bg-orange-image"
      />

      {/* Contenido sobre el fondo */}
      <div className="bg-orange-content">
        {/* Parte superior */}
        <div className="top-half">
          <div className="left-orange-column">
            <div className="responsive-container">
              <img
                className="responsive-image"
                src={logo}
                alt="Logo El Industrial"
              />
              <div className="responsive-text">
                <b style={{ color: "#23A638" }}>Innovamos medios</b> para
                promocionar a nuestros clientes.
              </div>
            </div>
          </div>

          <div className="right-column">
            <img
              src={lines}
              alt="Líneas"
              className="lines-image"
              loading="lazy"
            />
          </div>
        </div>

        {/* Parte inferior */}
        <div className="bottom-half">
          <div className="bottom-content">
            <h2 className="services-title">Conoce nuestros servicios:</h2>
            <div className="services-icons">
              <ServiceIcon
                icon={serviceIcon}
                alt="Publicidad"
                title="Publicidad"
              />
              <ServiceIcon icon={disenioIcon} alt="Diseño" title="Diseño" />
              <ServiceIcon
                icon={promotionIcon}
                alt="Promoción"
                title="Promoción"
              />
            </div>
            <div className="services-description">
              En medios impresos, electrónicos y exposiciones.
              <Link
                onClick={() => window.scrollTo(0, 0)}
                to="/servicios"
                className="read-more"
              >
                Ver más
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BgOrange;
